import { createSelector } from "reselect";

const selectedImageIdSelector = (state) => state.s2r.selectedImage?.id;
const selectedImageSelector = (state) => state.s2r.selectedImage;
const selectedRenderIdSelector = (state) => state.s2r.selectedRender?.id;
const selectedSketchIdSelector = (state) => state.s2r.selectedSketch?.id;
const recentImagesSelector = (state) => {
  if (!state.s2r.imageVersions) return;
  let arr = [];
  Object.values(state.s2r.imageVersions)?.forEach((val) => {
    arr.push(val[val?.length - 1]);
  });
  return arr;
};
const originalImagesSelector = (state) => {
  if (!state.s2r.imageVersions) return;
  let arr = [];
  Object.values(state.s2r.imageVersions)?.forEach((val) => {
    arr.push(val[0]);
  });
  return arr;
};
const selectedShaderSelector = (state) => state.s2r.shader;

// used to display sketches
const selectRecentSketches = createSelector(recentImagesSelector, (images) =>
  images?.filter((img) => img.imageType === "sketch")
);

// used to display the rendered images on sketch to render
const selectRecentRenders = createSelector(recentImagesSelector, (images) =>
  images?.filter((img) => img.imageType === "render")
);

// for histogram to read the oriingal image
const selectOriginalSketchVersion = createSelector(
  originalImagesSelector,
  selectedImageIdSelector,
  (images, selectedImageId) => {
    return images?.find((img) => img.id === selectedImageId);
  }
);

// grabs most recent Selected Image
const selectRecentImageVersion = createSelector(
  recentImagesSelector,
  selectedImageIdSelector,
  (recentImages, selectedImageId) => {
    return recentImages?.find((img) => img.id === selectedImageId);
  }
);

// grabs most recent sketch
const selectRecentSketchVersion = createSelector(
  recentImagesSelector,
  selectedSketchIdSelector,
  (recentImages, selectedImageId) => {
    return recentImages?.find((img) => img.id === selectedImageId);
  }
);
// grabs most recent sketch
const selectRecentRenderVersion = createSelector(
  recentImagesSelector,
  selectedRenderIdSelector,
  (recentImages, selectedImageId) => {
    return recentImages?.find((img) => img.id === selectedImageId);
  }
);

const selectedImage = createSelector(selectedImageSelector, (image) => {
  return image;
});

const selectedShader = createSelector(selectedShaderSelector, (shader) => {
  return shader;
});

const SKRSelectors = {
  selectRecentSketches,
  selectRecentRenders,
  selectOriginalSketchVersion,
  selectRecentSketchVersion,
  selectRecentRenderVersion,
  selectedImage,
  selectedShader,
  selectRecentImageVersion,
};

export default SKRSelectors;
